import React from "react";

const ArrowItem = ({}) => {
    return (
        <div className={`arrow-item`} data-testid={'arrowItemDiv'}>
            <img loading="lazy"
                 className="arrow-item-img"
                 src="../images/arrow-right.png"/>
        </div>
    );
};

export default ArrowItem;